import { IUser } from '../../types/strapi';

export interface AuthenticationState {
  user: IUser | null;
  jwt: string | null;
}

export const UPSERT_AUTHENTICATION = 'UPSERT_AUTHENTICATION';
export const DELETE_AUTHENTICATION = 'DELETE_AUTHENTICATION';

export interface UpsertAuthenticationAction {
  type: typeof UPSERT_AUTHENTICATION;
  payload: {
    user: IUser;
    jwt: string;
  };
}

export interface DeleteAuthenticationAction {
  type: typeof DELETE_AUTHENTICATION;
}

export type AuthenticationActionTypes = UpsertAuthenticationAction | DeleteAuthenticationAction;
